import { useAttendeeSeatsAddon } from "./useAttendeeSeatsAddon";
import { useStreamHoursAddon } from "./useStreamHoursAddon";

export const useLiveStreamsAddonsQuantities = () => {
  const {
    isLoading: isLoadingStreamHoursAddon,
    currentQuantity: streamHoursAddonQuantity,
    refetch: refetchStreamHours,
  } = useStreamHoursAddon();
  const {
    isLoading: isLoadingAttendeeSeatsAddon,
    currentQuantity: attendeeSeatsAddonQuantity,
    refetch: refetchAttendees,
  } = useAttendeeSeatsAddon();

  const isLoading = isLoadingStreamHoursAddon || isLoadingAttendeeSeatsAddon;
  const refetch = () => {
    // We will refetch all the addon quantities
    void refetchStreamHours();
    void refetchAttendees();
  };

  return {
    streamHoursAddonQuantity,
    attendeeSeatsAddonQuantity,
    isLoading,
    refetch,
  };
};
